var angular = require('angular');
require('angular-cookies');

var myApp = angular.module('myApp', [
    require('ng-admin'),'ngCookies'
]);

myApp.value('AUTH_TOKEN_NAME', 'kts_auth_token');
myApp.value('AUTH_LANG_NAME', 'kts_auth_lang');

require('./auth/')(myApp);
require('./pages/gold/')(myApp);
require('./actions/authorizepurchase')(myApp);
require('./actions/loginas')(myApp);
require('./actions/cancelpurchase')(myApp);
require('./actions/rightsDownloadReport')(myApp);
require('./actions/rightsStreamingReport')(myApp);
require('./actions/rightsSpaReport')(myApp);

myApp.config(['NgAdminConfigurationProvider','$stateProvider','$cookiesProvider', function (nga,$stateProvider,$cookiesProvider) {

    // create the admin application
    if (window.location.hostname.indexOf('lvarela') !== -1) {
        var admin = nga.application('Karaoketosing Test Admin').baseApiUrl('https://api.karaoke2sing.com/');
        $cookiesProvider.defaults.domain = '.lvarela.com';
    } else if (window.location.hostname.indexOf('karaoke2sing') !== -1) {
        var admin = nga.application('Karaoke2sing Admin').baseApiUrl('https://api.karaoke2sing.com/');
        $cookiesProvider.defaults.domain = '.karaoke2sing.com';
    } else {
        var admin = nga.application('Karaoketosing Admin').baseApiUrl('https://api.karaoketosing.com/');
        $cookiesProvider.defaults.domain = '.karaoketosing.com';
    }
        

    // menus
    var menu_main = nga.menu();
    var menu_admin = nga.menu().title("Admin");
    var menu_setup = nga.menu().title("Setup");
    
    /**
     * Configure entities
     */
    //code-name entities
    require('./_prototypes/setup')(nga, admin, menu_admin, 'producttypes', 'Product Types');
    require('./_prototypes/setup')(nga, admin, menu_admin, 'countries', 'Countries');
    require('./_prototypes/setup')(nga, admin, menu_admin, 'purchasemethods', 'Purchase Methods');
    require('./_prototypes/setup')(nga, admin, menu_admin, 'righttypes', 'Right Types');
    require('./_prototypes/setup')(nga, admin, menu_admin, 'productrights', 'Rights');
    require('./_prototypes/setup')(nga, admin, menu_admin, 'attributes', 'Attributes');
    require('./_prototypes/setup')(nga, admin, menu_admin, 'tags', 'Tags');
    
    
    //complex entities
    require('./entities/reports')(nga, admin, menu_main);
    require('./entities/product')(nga, admin, menu_main);
    require('./entities/user')(nga, admin, menu_main);
    require('./entities/productlist')(nga, admin, menu_setup);
    require('./entities/purchase')(nga, admin, menu_main);
    
    
    require('./entities/ftp')(nga, admin, menu_main);
    
    require('./entities/expiringsubscriptions')(nga, admin, menu_main);
    
    require('./entities/gold')(nga, admin, menu_main);
    
    require('./entities/track')(nga, admin, menu_setup);
    require('./entities/album')(nga, admin, menu_setup);
	
    require('./entities/discountcodes')(nga, admin, menu_main);
    
    admin.dashboard(
            nga.dashboard()
            .addCollection(nga.collection(nga.entity('users'))
                .title('Latest Users')
                .perPage(5)
                .fields([
                    nga.field('created_at', 'date').label('Registration Date'),
                    nga.field('email').isDetailLink(true),
                    nga.field('name')
                ])
                .sortField('created_at')
                .sortDir('DESC')
                .order(1))
            .addCollection(nga.collection(nga.entity('countries'))
                .title('Countries')
                .perPage(5)
                .fields([
                    nga.field('code').isDetailLink(true),
                    nga.field('name')
                ])
                .sortField('code')
                .sortDir('DESC')
                .order(2))
            .addCollection(nga.collection(nga.entity('purchases'))
                .title('Latest Purchases')
                .perPage(15)
                .fields([
                    nga.field('id').label('ID').isDetailLink(true),
                    nga.field('purchase_method_id', 'reference')
                        .targetEntity(nga.entity('purchasemethods'))
                        .targetField(nga.field('name'))
                        .label('Purchase Method'),
                    nga.field('amount').label('Amount'),
                    nga.field('vat_amount').label('Vat Amount'),
                    nga.field('status').label('Status'),
                    nga.field('created_at').label('Data da Criação'),
                    nga.field('user_id', 'reference')
                        .targetEntity(nga.entity('users'))
                        .targetField(nga.field('email'))
                        .label('User'),
                    nga.field('').label('').template('<kts-authorize-purchase purchase="entry.values"></kts-authorize-purchase><kts-cancel-purchase purchase="entry.values"></kts-cancel-purchase>')
                ])
                .sortField('created_at')
                .sortDir('DESC')
                .order(3))
                
    );

    //configure menus and stuff
    menu_main.addChild(menu_admin);
    menu_main.addChild(menu_setup);
    menu_main.addChild(nga.menu().title('Gold Clients').link('/gold'));
    admin.menu(menu_main);
    

    
    $stateProvider.state('login', {
        parent: 'ng-admin',
        url: '/login',
        controller: 'KtsAdminLoginController',
        controllerAs: 'controller',
        template: require('./auth/template.html')
    });
    
    $stateProvider.state('gold', {
        parent: 'ng-admin',
        url: '/gold',
        controller: 'KtsGoldController',
        controllerAs: 'controller',
        template: require('./pages/gold/template.html')
    });
    
        
    // attach the admin application to the DOM and execute it
    nga.configure(admin);
}]);



// WEBPACK FOOTER //
// ./js/main.js